/* eslint no-unused-vars: 0 */
export enum consentCategories {
    strictlyNecessaryCookies = 1,
    performanceCookies = 2,
    functionalCookies = 3,
    targetingCookies = 4,
    socialMediaCookies = 5,
    videoCookies = 'VID1',
}
